import React from 'react'

import Button from '../ButtonV1'

const ModalLink = ({
  type,
  label,
  handleClick,
  children,
  component,
  dispatch,
  ...rest
}) => {
  const Component = component || (type === 'button' ? Button : 'span')
  return (
    <Component {...rest} onClick={handleClick}>
      {children || label}
    </Component>
  )
}

export default ModalLink
